import {Box, Flex, P, Span} from 'exsportia-components'
import {FC, useCallback} from 'react'

import {CycleToShow} from '../../../api/subscription-bookings/helpers'
import {SubscriptionBooking} from '../../../api/subscription-bookings/types'
import {TranslatorScope} from '../../../locale/types'
import {CurrenciesEnum} from '../../../types/currencies'
import {ExsportiaIcon} from '../../../ui/components/exsportia-icon/exsportia-icon'
import {useLocale} from '../../../utils/i18n'

type Props = {
  isPaidAdditionalFee: SubscriptionBooking['isPaidAdditionalFee']
  additionalFee: SubscriptionBooking['additionalFee']
  transaction: SubscriptionBooking['cycles'][number]['transactions'][number]
  openInvoicePdf: (_: CycleToShow['transactions'][number]) => void
  currency: CurrenciesEnum
}

export const AdditionalFeeRow: FC<Props> = ({
  isPaidAdditionalFee,
  additionalFee,
  transaction,
  openInvoicePdf,
  currency,
}) => {
  // eslint-disable-next-line
  const canDownload = Boolean(transaction?.transactionId && transaction?.docType)
  const handleOpenInvoicePdf = useCallback(() => {
    if (canDownload) {
      openInvoicePdf(transaction)
    }
  }, [openInvoicePdf])
  const {l} = useLocale()
  const color = isPaidAdditionalFee ? 'success' : 'notify'

  return (
    <Flex
      flex={1}
      height={'40px'}
      cursor={canDownload ? 'pointer' : 'default'}
      onClick={handleOpenInvoicePdf}
      flexDirection={'row'}
      alignItems={'center'}
    >
      {
        isPaidAdditionalFee
          ? canDownload
            && (
              <Box mr={'12px'}>
                <ExsportiaIcon icon={'download'} color={'iconSecondary'}/>
              </Box>
            )
          : (
            <Box mr={'12px'}>
              <ExsportiaIcon icon={'warning'} color={color}/>
            </Box>
          )
      }
      <Flex
        flex={1}
        flexDirection={'row'}
        alignItems={'center'}
      >
        <P variant={'footnote'}>
          <Span>
            {`${l('registration_fee', {caseAction: 'capitalize'})} · `}
          </Span>
          <Span
            color={color}
          >
            {l(isPaidAdditionalFee ? 'paid' : 'awaitingPayment')}
          </Span>
        </P>
      </Flex>
      <Span
        pl={'8'}
        variant={'body'}
        color={color}
      >
        {l(`${currency}_symbolic` as TranslatorScope, {value: additionalFee})}
      </Span>
    </Flex>
  )
}

